<template>
  <div class="viewContent">
    <template v-if="level==1 || level==2 || level==3">
      <l-dialog
        :show="isMark"
        @cancel="isMark=false"
        @save="saveMarkModel()"
        class="markDialog"
        title="编辑回复模板"
      >
        <div class="ipt" style="margin-bottom:.3rem">
          <span class="label">编辑方式：</span>
          <el-radio-group v-model="modelType" @change="modelTypeChange">
            <el-radio :label="1">新增模板</el-radio>
            <el-radio :label="2">修改模板</el-radio>
          </el-radio-group>
        </div>
        <div class="ipt" style="margin-bottom:.2rem" v-if="modelType==1">
          <span class="label">模版名称：</span>
          <el-input v-model="modelTitle" placeholder="请输入内容" style="width:3rem"></el-input>
        </div>
        <div class="ipt" style="margin-bottom:.2rem" v-else>
          <span class="label">模版名称：</span>
          <el-select
            v-model="modelTitles"
            placeholder="请选择"
            style="width:3rem"
            @change="markChange"
            value-key="id"
          >
            <el-option
              v-for="item in markList"
              :key="item.id"
              :label="item.title"
              :value="item"
              @change="markChange"
            ></el-option>
          </el-select>
        </div>
        <div class="ipt" style="margin-bottom:.2rem">
          <span class="label">模版内容：</span>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="modelMsg"
            style="width:5.4rem"
          ></el-input>
        </div>
      </l-dialog>
      <l-dialog
        :show="isInfo"
        :isbtn="false"
        :ischa="true"
        @cancel="isInfo=false;getResult()"
        class="msgDialog"
        title="普查测评结果"
      >
        <div class="oneLeft" v-show="!showEchart">
          <h1>{{info.title}}</h1>
          <p class="tag">包含{{childList.length}}量表</p>
          <div class="tab">
            <table>
              <tr>
                <th style="width:3.2rem">量表名称</th>
                <th style="width:2.2rem">量表分类</th>
                <th style="width:1rem">操作</th>
              </tr>
              <tr v-for="(item,index) in childList" :key="index">
                <td style="text-align:left;padding-left:.2rem">{{item.gaugeTitle}}</td>
                <td>{{resultInfo.title}}</td>
                <td>
                  <l-button value="查看" color="#3170FF" @click.native="handLookInfo(item)"></l-button>
                  <div class="bad" v-show="item.isRead==0"></div>
                </td>
              </tr>
            </table>
          </div>
          <p class="markTitle">—— 对本次普查的整体点评 ——</p>
          <div class="eval">
            <el-input type="textarea" :rows="5" placeholder="请输入点评内容" v-model="mark"></el-input>
            <div class="foot">
              <el-checkbox v-model="showResult">允许用户查看结果</el-checkbox>
              <div class="mark">
                <div class="flot" v-show="isFlot">
                  <ul>
                    <li
                      v-for="(item,index) in markList"
                      :key="index"
                      @click="mark=item.comment,isFlot=false"
                    >{{item.title}}</li>
                    <li @click="isMark=true,isFlot=false">
                      <i class="el-icon-edit-outline"></i> 编辑模版
                    </li>
                  </ul>
                </div>
                <p style="margin-right:.4rem" @click="useMark()">使用点评模板</p>
                <p @click="handComment()">
                  <img src="../../../assets/img/home/fj.png" /> 发布点评
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="left" v-show="showEchart">
          <p class="tit">测试结果</p>
          <div ref="bar" id="bar" style="height:3rem;width:6.2rem"></div>
          <div v-for="(item,index) in recordResult" :key="index" style="padding-right:.5rem">
            <p class="tag">【{{item.gradeName}}】：{{item.scores}}</p>
            <p class="tag">{{item.degree}}</p>
            <p class="msg" v-html="item.result"></p>
          </div>
        </div>
        <div class="right">
          <p class="tit">—— 用户资料 ——</p>
          <p>
            姓名：
            <span>{{info.nickname}}</span>
          </p>
          <p>
            性别：
            <span>{{info.sex}}</span>
          </p>
          <p>
            年龄：
            <span>{{info.age}}</span>
          </p>
          <p>
            部门：
            <span>{{info.deptname}}</span>
          </p>
          <p>
            编号：
            <span>{{info.student_id}}</span>
          </p>
          <p>
            生成：
            <span>{{formatDate(info.addTime)}}</span>
          </p>
          <div class="btn" v-show="!showEchart">
            <l-button value="删除" color="#3170FF" @click.native="operate(4)"></l-button>
            <l-button value="导出" color="#FF500C" @click.native="exportWord()"></l-button>
            <l-button value="关闭" @click.native="isInfo=false;getResult()"></l-button>
          </div>
          <div class="btn2" v-show="showEchart">
            <!-- <l-button value="导出" color="#FF500C" @click.native="exportWord()"></l-button> -->
            <l-button value="关闭" @click.native="showEchart=false,getChildList();"></l-button>
          </div>
        </div>
      </l-dialog>
      
      
      <l-dialog
        :show="exportingAllBox.show"
        :ischa="true"
        :isbtn="false"
        title="筛选导出报告"
        @cancel="exportingAllBox.show = false"
      >
        <div class="exportingAllBox">
          <div class="box-main">
            <p class="label-box_row"><span style="color:#FF4733">*</span>请选择要导出结果的普查：</p>
            <div class="value-box_row">
              <el-input class="scale-input" :value="exportingAllBox.scaleBox.scaleNum" placeholder="请选择普查"></el-input>
              <l-button value="选择" color="#3170FF" @click.native="exportingAllBox.scaleBox.show=true"></l-button>
            </div>

            <p class="label-box_row">选择导出对象：</p>
            <div class="value-box_row">
              <el-checkbox-group v-model="exportingAllBox.checkClassList" @change="handClassChange">
                <div><el-checkbox label="" @change="checkClassAll">所有部门（全校）</el-checkbox></div>
                <div v-for="(item, index) of classList" :key="index"><el-checkbox :label="item.deptid">{{item.deptname}}</el-checkbox></div>
              </el-checkbox-group>
            </div>

            <div class="value-box_row value-box_sex">
              <div class="box-label"><span>按用户性别筛选：</span></div>
              <el-checkbox-group v-model="exportingAllBox.checkSex" @change="handSexChange">
                <div><el-checkbox label="0">不限</el-checkbox></div>
                <div><el-checkbox label="1">男性用户</el-checkbox></div>
                <div><el-checkbox label="2">女性用户</el-checkbox></div>
              </el-checkbox-group>
            </div>
            
            <div class="value-box_row value-box_date">
              <div class="box-label"><span>日期筛选：</span></div>
              <el-date-picker v-model="exportingAllBox.startDate" type="date" placeholder="选择日期" @change="getExportNum"></el-date-picker>
              <span>~</span>
              <el-date-picker v-model="exportingAllBox.endDate" type="date" placeholder="选择日期" @change="getExportNum"></el-date-picker>
            </div>

            <div class="label-total"><span>本次导出报告数量：{{exportingAllBox.total}}份</span></div>

            <div class="value-box_row">
              <div class="box-label"><span>导出包命名：</span></div>
              <el-input class="input" v-model="exportingAllBox.fileName" placeholder=""></el-input>
            </div>
          </div>
          <div class="btn-box_bottom">
            <l-button value="导出" color="#3170FF" @click.native="exportingAll(exportingAllBox.recordIds, exportingAllBox.fileName)"></l-button>
            <l-button value="重置" color="#EFBC00" @click.native="exportingReset()"></l-button>
          </div>
        </div>
      </l-dialog>
      <l-dialog
        :show="exportingAllBox.scaleBox.show"
        :ischa="true"
        isbtn="cancel"
        val2="确定"
        val2color="#3170ff"
        title="选择器"
        @cancel="exportingAllBox.scaleBox.show = false"
      >
        <div class="scaleBox">
          <div class="th">
            <span style="width:1.6rem;padding-left:.15rem;box-sizing:border-box">
              <el-checkbox v-model="exportingAllBox.scaleBox.checkAll" @change="scaleHandAll"></el-checkbox>全选
            </span>
            <span style="width:2.9rem;text-align:center">普查列表</span>
          </div>
          <div class="tb">
            <ul class="tbl">
              <li
                v-for="(item,index) in exportingAllBox.scaleBox.scaleList"
                :key="index"
                :class="exportingAllBox.scaleBox.typeId==index ? 'active' : ''"
                @click="scaleActive(index)"
              >
                <el-checkbox v-if="exportingAllBox.scaleBox.checkTypeAll[index]" v-model="exportingAllBox.scaleBox.checkTypeAll[index].select" :indeterminate="exportingAllBox.scaleBox.checkTypeAll[index].isIndeterminate" @change="scaleHandTypeAll(exportingAllBox.scaleBox.checkTypeAll[index])" :key="index"></el-checkbox>
                {{item.catName}}
              </li>
            </ul>
            <div class="autoTbr">
              <el-checkbox-group v-model="exportingAllBox.scaleBox.checkList[exportingAllBox.scaleBox.typeId]" @change="scaleHandChange">
                <ul class="tbr" v-if="exportingAllBox.scaleBox.scaleList[exportingAllBox.scaleBox.typeId]">
                  <li v-for="(item,index) in exportingAllBox.scaleBox.scaleList[exportingAllBox.scaleBox.typeId].gaugeList" :key="index">
                    <el-checkbox :label="item">{{item.title}}</el-checkbox>
                  </li>
                </ul>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </l-dialog>
      <l-dialog
        :show="exportingBox.show"
        :ischa="true"
        title="导出报告"
        val1="导出"
        val2="取消"
        @save="exportingAll(exportingBox.recordIds, exportingBox.fileName)"
        @cancel="exportingBox.show = false"
      >
        <div class="exportingBox">
          <div class="label-total"><span>本次导出报告数量：{{exportingBox.recordIds.length}}份</span></div>

          <div class="value-box_row">
            <div class="box-label"><span>导出包命名：</span></div>
            <el-input class="input" v-model="exportingBox.fileName" placeholder=""></el-input>
          </div>
        </div>
      </l-dialog>

      
      <div class="search">
        <p>您可以在这里管理所有的量表：</p>
        <div>

          <template v-if="!batchingObj.isOn">
            <l-button
              :shape="2"
              value="批量处理"
              color="#3170FF"
              class="bt1"
              @click.native="batchingStart()"
            ></l-button>
          </template>

          <template v-if="batchingObj.isOn">
            <l-button
              :shape="2"
              value="批量删除"
              color="#3170FF"
              class="bt1"
              @click.native="batchingDelete()"
            ></l-button>
            <l-button
              :shape="2"
              value="结束操作"
              color="#159BE0"
              class="bt1"
              @click.native="batchingEnd()"
            ></l-button>
          </template>
          
          <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="search">
            <template slot="append">
              <span @click="getResult({})">搜索</span>
            </template>
          </el-input>
        </div>
      </div>
      <div class="table"
        v-loading="batchingObj.loading"
        :element-loading-text="batchingObj.loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="type">共有普查测评结果：{{queryObj.total}}份</div>
        <table style="padding:0 .35rem;width: 100%;">
          <tr>
            <th style="width:.6rem">
              <el-checkbox v-model="checkAll" @change="handAll" />全选
            </th>
            <th style="width:1.3rem">用户姓名</th>
            <th style="width:.7rem" @click="sexTh = !sexTh">
              性别
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="selectSex" :show.sync="sexTh">
                <p :class="{'on':queryObj.sex == ''}" @click="getResult({sex:'',page: 1})">全部</p>
                <p :class="{'on':queryObj.sex == '男'}" @click="getResult({sex:'男',page: 1})">男</p>
                <p :class="{'on':queryObj.sex == '女'}" @click="getResult({sex:'女',page: 1})">女</p>
              </eject-select-list>
            </th>
            <th style="width:1.7rem" @click="classTh = !classTh,getClass()">
              所在部门
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="selectClass" :show.sync="classTh">
                <p :class="{'on':queryObj.cid == ''}" @click="getResult({cid:'',page: 1})">全部</p>
                <p
                  v-for="(item,index) in classList"
                  :key="index"
                  :class="{'on':queryObj.cid == item.deptid}"
                  @click="getResult({cid:item.deptid,page: 1})"
                >{{item.deptname}}</p>
              </eject-select-list>
            </th>
            <th style="width:3.25rem" @click="scaleTh = !scaleTh">
              普查任务名称
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="selectScale" :show.sync="scaleTh">
                <p :class="{'on':queryObj.sort == 'asc'}" @click="getResult({time:'',sort:'asc',})">按拼音（正序）</p>
                <p :class="{'on':queryObj.sort == 'desc'}" @click="getResult({time:'',sort:'desc',})">按拼音（倒序）</p>
              </eject-select-list>
            </th>
            <th style="width:1.5rem">包含量表</th>
            <th style="width:1.65rem" @click="timeTh = !timeTh">
              结果生成日期
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="selectTime" :show.sync="timeTh">
                <l-date-picker v-model="queryObj.date" @change="getResult({page:1})"></l-date-picker>
                <!--<p @click="isDate=!isDate">选择日期范围</p>
                <div v-show="isDate" style="margin-top:.05rem">
                  <div>
                    <el-input v-model="startDate" style="width:.9rem"></el-input>
                    <span style="margin:0 5px">-</span>
                    <el-input v-model="endDate" style="width:.9rem"></el-input>
                    <i
                      class="el-icon-search"
                      style="font-size:.18rem;margin-left:.05rem"
                      @click="getResult({page: 1}),timeTh=false"
                    ></i>
                  </div>
                  <Calendar
                    @choseDay="clickDay"
                    @changeMonth="changeDate"
                    :markDate="markDate"
                    ref="cale"
                  />
                </div>-->
                <p :class="{'on':queryObj.time == 'asc'}" @click="getResult({time:'asc',sort:''})">按最远建立排序</p>
                <p :class="{'on':queryObj.time == 'desc'}" @click="getResult({time:'desc',sort:''})">按最近建立排序</p>
              </eject-select-list>
            </th>
            <th style="width:1.5rem" @click="statusTh = !statusTh">
              结果是否可查看
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="selectStatus" :show.sync="statusTh">
                <p :class="{'on':queryObj.status == ''}" @click="getResult({status:'',page: 1})">全部</p>
                <p :class="{'on':queryObj.status == 1}" @click="getResult({status:1,page: 1})">可查看</p>
                <p :class="{'on':queryObj.status == 2}" @click="getResult({status:2,page: 1})">不可查看</p>
              </eject-select-list>
            </th>
            <th v-if="!batchingObj.isOn" style="width:1.3rem">操作</th>
          </tr>
        </table>
        <el-checkbox-group v-if="!batchingObj.isOn" v-model="checkLists" @change="handChange">
          <div class="grid">
            <div>
              <table style="padding-left :.35rem;width:12.55rem" cellspacing="0">
                <tr v-for="(item) in resultList" :key="item.publishId" @click="clickRow(item)" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }">
                  <td style="width:1.9rem">
                    <div class="td1">
                      <div>
                        <el-checkbox :label="item" />
                      </div>
                      <div class="bad" v-show="item.isCheck==0"></div>
                      <img :src="global.ip+item.avatar" />
                      {{item.nickname}}
                    </div>
                  </td>
                  <td style="width:.7rem">{{item.sex}}</td>
                  <td style="width:1.7rem">{{item.deptname}}</td>
                  <td style="width:3.2rem">
                    <div class="td4">
                      <img src="@/assets/img/home/pc.png" alt />
                      {{item.title}}
                    </div>
                  </td>
                  <td style="width:1.5rem">{{item.gaugeTotal}}</td>
                  <td style="width:1.65rem">{{formatDate(item.addTime)}}</td>
                  <td
                    style="width:1.5rem"
                  >{{item.isView==1 ? '可查看' : item.isView==2 ? '不可查看' : '待批阅'}}</td>
                </tr>
              </table>
            </div>
            <div class="right">
              <l-button value="查看" color="#3170FF" @click.native="handLook()"></l-button>
              <l-button value="标为已读" color="#00BB81" @click.native="operate(1)"></l-button>
              <l-button value="设为可查看" color="#3170FF" @click.native="operate(2)"></l-button>
              <l-button value="设为不可查看" color="#3170FF" @click.native="operate(3)"></l-button>
              <!-- <l-button value="导出" color="#FF500C" @click.native="batchExport()"></l-button> -->
              <l-button value="导出" color="#FF500C" @click.native="exportingCheck()"></l-button>
              <l-button value="筛选导出" color="#EFBC00" @click.native="exportingBoxShow()"></l-button>
              <l-button value="删除" color="#F0F0F0" style="color:#333333" @click.native="operate(4)"></l-button>
            </div>
          </div>
        </el-checkbox-group>

        <big-data-roll class="data-table" v-if="batchingObj.isOn" :list="resultList" :rowHeight="57">
          <template v-slot:default="slotProps">
            <el-checkbox-group v-model="checkLists" @change="handChange">
              <div class="grid">
                <div>
                  <table style="padding-left: .35rem;width:100%;" cellspacing="0">
                    <tr v-for="(item) in slotProps.list" :key="item.publishId" @click="clickRow(item)" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }">
                      <td style="width:1.9rem">
                        <div class="td1">
                          <div>
                            <el-checkbox :label="item" />
                          </div>
                          <div class="bad" v-show="item.isCheck==0"></div>
                          <img :src="global.ip+item.avatar" />
                          {{item.nickname}}
                        </div>
                      </td>
                      <td style="width:.7rem">{{item.sex}}</td>
                      <td style="width:1.7rem">{{item.deptname}}</td>
                      <td style="width:3.2rem">
                        <div class="td4">
                          <img src="@/assets/img/home/pc.png" alt />
                          {{item.title}}
                        </div>
                      </td>
                      <td style="width:1.5rem">{{item.gaugeTotal}}</td>
                      <td style="width:1.65rem">{{formatDate(item.addTime)}}</td>
                      <td
                        style="width:1.5rem"
                      >{{item.isView==1 ? '可查看' : item.isView==2 ? '不可查看' : '待批阅'}}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </el-checkbox-group>
          </template>
        </big-data-roll>

      </div>
      <el-pagination
        v-if="!batchingObj.isOn"
        background
        layout="prev, pager, next"
        :total="queryObj.total"
        :currentPage="queryObj.page"
        :page-size="queryObj.pageSize"
        @current-change="changePage"
      ></el-pagination>
    </template>
    <template v-else>
      <user-result />
    </template>
  </div>
</template>

<script>
require("../../../utils/export/jquery.wordexport");
import lButton from "@/components/lButton.vue";
import lDialog from "@/components/lDialog.vue";
import userResult from "./template/userResult.vue";
import { formatDate1 } from "../../../assets/js/formatDate";
import { formatDate2 } from "@/utils/common/formatDate.js";
import Calendar from "vue-calendar-component";
let bar = "";
let bar1 = "";
export default {
  data() {
    return {
      uid: JSON.parse(localStorage.getItem("userinfo")).uid,
      level: JSON.parse(localStorage.getItem("userinfo")).level,
      resultList: [],
      childList: [],
      classList: [],
      sexTh: false,
      scaleTh: false,
      classTh: false,
      personTh: false,
      timeTh: false,
      statusTh: false,
      search: "",
      //详情
      isInfo: false,
      showResult: true,
      showEchart: false,
      info: {},
      resultInfo: {},
      mark: "",
      //图表
      recordResult: {},
      recordInfo: {},
      record: [],
      //模板
      isFlot: false,
      isMark: false,
      markList: [],
      modelType: 1,
      modelTitles: {},
      modelTitle: "",
      modelMsg: "",
      //全选
      nowClickRow: null,
      checkAll: false,
      checkLists: [],
      //分页
      page: 1,
      total: 0,
      pageSize: 10,
      //echarts
      base64: "",
      //日期
      isDate: false,
      startDate: "",
      endDate: "",
      markDate: [],
      
      exportingAllBox: {
        show: false,
        loading: false,
        recordIds: [],

        checkClassList: [''],
        checkSex: [''],
        startDate: '',
        endDate: '',
        fileName: '',

        total: 0,

        scaleBox: {
          show: false,
          scaleNum: '',

          scaleList: [{ gaugeList: [] }],
          typeId: 0,
          scaleIds: [],
          checkAll: false,
          checkTypeAll: [{ select: false, isIndeterminate: false, }],
          checkList: [],
        },
      },
      exportingBox: {
        show: false,
        recordIds: [],
        total: 0,
        fileName: '',
      },

      queryObj: {
        sex: '',
        cid: '',
        sort: '',
        date: [],
        time: '',
        status: '',
        page: 1,
        pageSize: 10,
        total: 0,
      },

      batchingObj: {
        isOn: false,
        loading: false,
        loadingText: '',
        dataNum: 0,
      },
    };
  },
  methods: {
    //echarts
    handEcharts() {
      //销毁echarts实例
      if (bar) {
        bar.dispose();
      }
      if (bar1) {
        bar1.dispose();
      }
      bar = this.echarts.init(this.$refs.bar);
      bar1 = this.echarts.init(this.$refs.bar);
      let colors = ['#0AA7F4','#ED6942','#F29EC2','#36D5E5','#12B5B0','#F9B552','#e91e63','#f44336','#EEAD0E','#E066FF','#B3EE3A'];
      let option = {
        animation: false,
        backgroundColor: "#fff",
        grid: {
          top: "30",
          left: "40",
          right: "50",
          bottom: "60",
        },
        xAxis: {
          type: "category",
          //data: Array.from({ length: this.record.length }, (x, i) => x + i),
          axisLine: {
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 7], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: true, //---是否显示
            inside: true, //---是否朝内
            lengt: 2, //---长度
            lineStyle: {
              //color:'red',			//---默认取轴线的颜色
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 30,
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 10], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: false, //---是否显示
          },
          splitLine: {
            //---grid 区域中的分隔线
            show: true, //---是否显示，'category'类目轴不显示，此时我的X轴为类目轴，splitLine属性是无意义的
            lineStyle: {
              color: "#404040",
              opacity: "0.2",
              width: 1,
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              //---图形形状
              borderRadius: [5, 5, 0, 0],
              color: function (params) {
                return colors[params.dataIndex % colors.length];
              },
            },
            barWidth: 20, //---柱形宽度
            // barCategoryGap: "20%", //---柱形间距
            data: this.record,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      bar.setOption(option);
      bar1.setOption(option);
      var opts = {
        //type: "jpeg", // 导出的格式，可选 png, jpeg
        pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
        backgroundColor: "#fff", // 导出的图片背景色，默认使用 option 里的 backgroundColor
      };
      this.base64 = bar1.getDataURL(opts); //拿到base64 地址
      window.addEventListener("resize", function () {
        bar.resize();
        bar1.resize();
      });
    },
    // 导出勾选
    exportingCheck () {
      let itemList = [],
          itemTypeName = ''
      if (this.checkLists.length > 0) {
        itemList = this.checkLists
        itemTypeName = '勾选'
      } else if (this.nowClickRow) {
        itemList = [this.nowClickRow]
        itemTypeName = '选中'
      } else {
        this.$myMessage("请选择一条数据！");
        return;
      }
      let ids = itemList.map((item) => {
        return item.publishId;
      });
      this.exportingBox.recordIds = ids
      this.exportingBox.fileName = '普查_' + formatDate2(new Date, 'yyyy-MM-dd') + '测试报告'
      this.exportingBox.show = true
    },
    //导出
    exportWord() {
      this.exportingAll([this.info.publishId], this.info.title)
    },
    // 导出全部
    exportingBoxShow() {
      this.getScale()
      this.exportingReset()
      this.exportingAllBox.show = true
    },
    getExportNum () {
      if (this.exportingAllBox.scaleBox.scaleIds.length > 0) {
        this.$post("api/export/filterSurveyRecord", {
          taskids: this.exportingAllBox.scaleBox.scaleIds.toString(),
          deptids: this.exportingAllBox.checkClassList.toString(),
          sexType: this.exportingAllBox.checkSex[0],
          starttime: formatDate2(this.exportingAllBox.startDate, 'yyyy-MM-dd'),
          endtime: formatDate2(this.exportingAllBox.endDate, 'yyyy-MM-dd'),
        }).then(({ data }) => {
          if (data.code == 0) {
            this.exportingAllBox.recordIds = data.data.recordId
            this.exportingAllBox.total = data.data.total
          }
        })
      }
    },
    exportingAll(ids, fileName) {
      if (ids.length <= 0) {
        this.$myMessage("没有符合条件的数据，请重新选择");
        return
      }
      this.$post("api/export/surveyWordExport", {
        name: fileName,
        ids: ids.toString(),
      }).then(({ data }) => {
        console.log(data.data.path)
        this.$saveAs(this.global.ip + data.data.path.replace(/^\.\//, ''), fileName)
        this.exportingAllBox.show = false
        this.exportingBox.show = false
      })
    },
    exportingReset () {
      this.exportingAllBox.recordIds = []
      this.exportingAllBox.total = 0
      this.exportingAllBox.checkClassList = ['']
      this.exportingAllBox.checkSex = ['0']
      this.exportingAllBox.startDate = new Date
      this.exportingAllBox.endDate = new Date
      this.exportingAllBox.fileName = '普查_' + formatDate2(new Date, 'yyyy-MM-dd') + '测试报告'

      this.exportingAllBox.scaleBox.checkAll = false
      this.exportingAllBox.scaleBox.checkTypeAll.forEach((item, index) => {
        this.exportingAllBox.scaleBox.checkTypeAll[index].select = false;
        this.exportingAllBox.scaleBox.checkList[index] = [];
        this.exportingAllBox.scaleBox.checkTypeAll[index].isIndeterminate = false
      });
      this.saveScale()
    },
    checkClassAll (val) {
      if (val) {
        this.exportingAllBox.checkClassList = ['']
      }
    },
    handClassChange (val) {
      if (val.length > 1) {
        let dIndex = this.exportingAllBox.checkClassList.indexOf('')
        if (dIndex > -1) {
          this.exportingAllBox.checkClassList.splice(dIndex, 1)
        }
      }
      this.getExportNum()
    },
    handSexChange (val) {
      if (val.length > 1) {
        this.exportingAllBox.checkSex.splice(0, val.length - 1)
      }
      this.getExportNum()
    },
    //获取普查
    async getScale() {
      let { data } = await this.$post("api/export/taskList", { testType: 3, });
      this.exportingAllBox.scaleBox.scaleList = [
        { 
          catId: 1, 
          catName: '全部', 
          gaugeList: data.data.list.map((item)=>{
            return {
              id: item.taskId,
              title: item.title,
            }
          })
        }
      ];
      this.exportingAllBox.scaleBox.checkTypeAll = Array.from({ length: this.exportingAllBox.scaleBox.scaleList.length }, () => {
        return {
          select: false,
          isIndeterminate: false,
        };
      });
      this.exportingAllBox.scaleBox.checkList = Array.from({ length: this.exportingAllBox.scaleBox.scaleList.length }, () => {
        return [];
      });
      // console.log(data);
    },
    //选择分类
    scaleActive(index) {
      this.exportingAllBox.scaleBox.typeId = index;
    },
    //全选
    scaleHandAll(val) {
      if (val) {
        this.exportingAllBox.scaleBox.checkTypeAll.forEach((item, index) => {
          this.exportingAllBox.scaleBox.checkTypeAll[index].select = true;
          this.exportingAllBox.scaleBox.checkList[index] = this.exportingAllBox.scaleBox.scaleList[index].gaugeList;
          this.exportingAllBox.scaleBox.checkTypeAll[index].isIndeterminate = false
        });
      } else {
        this.exportingAllBox.scaleBox.checkTypeAll.forEach((item, index) => {
          this.exportingAllBox.scaleBox.checkTypeAll[index].select = false;
          this.exportingAllBox.scaleBox.checkList[index] = [];
          this.exportingAllBox.scaleBox.checkTypeAll[index].isIndeterminate = false
        });
      }
      this.saveScale()
    },
    //分类
    scaleHandTypeAll(itemObj) {
      let count = this.exportingAllBox.scaleBox.checkTypeAll.filter((item) => {
        return item.select == true;
      });
      //分类普查联动
      this.exportingAllBox.scaleBox.checkList[this.exportingAllBox.scaleBox.typeId] = itemObj.select
        ? this.exportingAllBox.scaleBox.scaleList[this.exportingAllBox.scaleBox.typeId].gaugeList
        : [];
      this.exportingAllBox.scaleBox.checkAll = count.length == this.exportingAllBox.scaleBox.scaleList.length;
      itemObj.isIndeterminate = false
      this.saveScale()
    },
    //普查
    scaleHandChange(val) {
      let status = val.length == this.exportingAllBox.scaleBox.scaleList[this.exportingAllBox.scaleBox.typeId].gaugeList.length;
      this.$set(this.exportingAllBox.scaleBox.checkTypeAll[this.exportingAllBox.scaleBox.typeId], 'select', status);
      let isIndeterminate = val.length > 0 && val.length < this.exportingAllBox.scaleBox.scaleList[this.exportingAllBox.scaleBox.typeId].gaugeList.length
      this.$set(this.exportingAllBox.scaleBox.checkTypeAll[this.exportingAllBox.scaleBox.typeId], 'isIndeterminate', isIndeterminate);
      let count = this.exportingAllBox.scaleBox.checkTypeAll.filter((item) => {
        return item.select == true;
      });
      this.exportingAllBox.scaleBox.checkAll = count.length == this.exportingAllBox.scaleBox.scaleList.length;
      this.saveScale()
    },
    //选择普查
    saveScale() {
      let list = this.exportingAllBox.scaleBox.checkList.flat();
      let num = list.length;
      this.exportingAllBox.scaleBox.scaleNum = `已选择${num}个普查`;
      this.exportingAllBox.scaleBox.scaleIds = list.map((item) => {
        return item.id;
      });
      this.getExportNum()
    },

    //获取结果列表
    async getResult(qObj = this.queryObj) {
      qObj = Object.assign(this.queryObj, qObj)

      // 批量处理数据
      if (this.batchingObj.isOn) {
        this.batchingGetTableData(qObj)
        return
      }

      let { data } = await this.$post("api/test/getTableResultList", {
        testType: 3,
        curPage: qObj.page,
        pageSize: qObj.pageSize,
        name: this.search,
        starttime: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
        endtime: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
        sex: qObj.sex,
        catId: qObj.cid,
        title_desc: qObj.sort,
        time_desc: qObj.time,
        isView: qObj.status,
      });
      this.nowClickRow = null
      this.checkAll = false;
      this.checkLists = [];
      this.resultList = data.data.list;
      this.queryObj.total = data.data.total;
    },
    //获取部门
    async getClass() {
      let { data } = await this.$post("api/msg/dept", {});
      this.classList = data.data.list;
    },
    //获取子任务列表
    async getChildList() {
      let { data } = await this.$post("api/test/getSurveyResultList", {
        publishId: this.info.publishId,
      });
      this.childList = data.data.list;
      this.resultInfo = data.data.info;
      this.mark = this.resultInfo.comment;
      console.log(data);
    },
    //查看
    async handLook() {
      if (!this.nowClickRow) {
        this.$myMessage("请选择一条数据！");
        return;
      }
      this.showEchart = false;
      this.isInfo = true;
      this.info = this.nowClickRow
      //获取子任务列表
      this.getChildList();
      if (this.info.isCheck == 0) {
        await this.$post("api/test/tableResultOperate", {
          testType: 3,
          type: 1,
          id: this.info.publishId,
          publishId: this.info.publishId,
        }).then(()=>{
          this.getResult();
          // this.info.isCheck = 1
        })
      }
    },
    //查看子列表详情
    async handLookInfo(item) {
      this.showEchart = true;
      //已读
      await this.$post("api/test/getReadTable", {
        testType: 3,
        id: item.recordId,
      });
      let { data } = await this.$post("api/test/getTableResultById", {
        id: item.recordId,
      });

      let recordResult = data.data.list.recordResult
      let resultCategory = []
      for (let key in recordResult) {
        resultCategory.push(recordResult[key])
      }

      this.recordResult = recordResult;
      data.data.list.recordResult = recordResult
      this.recordInfo = data.data.list;
      this.record = this.recordResult.map((item) => {
        return [item.gradeName, item.scores];
      });
      this.handEcharts();
      console.log(data);
    },
    //已读
    async setRead() {
      let itemList = [],
          itemTypeName = ''
      if (this.checkLists.length > 0) {
        itemList = this.checkLists
        itemTypeName = '勾选'
      } else if (this.nowClickRow) {
        itemList = [this.nowClickRow]
        itemTypeName = '选中'
      } else {
        this.$myMessage("请选择一条数据！");
        return;
      }
      let ids = itemList.map((item) => {
        return item.publishId;
      });
      await this.$post("api/test/getReadTable", {
        testType: 3,
        id: ids.toString(),
      });
      this.getResult();
    },
    //是否可查看、删除
    async operate(type) {
      let itemList = [],
          itemTypeName = ''
      if (this.checkLists.length > 0) {
        itemList = this.checkLists
        itemTypeName = '勾选'
      } else if (this.nowClickRow) {
        itemList = [this.nowClickRow]
        itemTypeName = '选中'
      } else {
        this.$myMessage("请选择一条数据！");
        return;
      }

      let foo = ()=>{
        let ids = itemList.map((item) => {
          return item.publishId;
        });
        this.$post("api/test/tableResultOperate", {
          testType: 3,
          type: type,
          id: ids.toString(),
          publishId: ids.toString(),
        }).then(()=>{
          this.isInfo = false;
          this.info = {};
          if (type == 4) {
            // 处理删除整页的情况，当不是最后一页时，当前页数减一
            if (ids.length == this.resultList.length) {
              // 判断是否为最后一页
              if (this.queryObj.page == Math.ceil(this.queryObj.total / this.queryObj.pageSize)) {
                this.queryObj.page = this.queryObj.page > 1 ? this.queryObj.page - 1 : 1;
              }
            }
          }
          this.getResult();
        })
      }

      if (type == 4) {
        this.$popup({
          title: '提示',
          content: '是否要删除' + itemTypeName + '的记录？',
          saveFoo: () => {
            foo()
          },
        })
      } else {
        foo()
      }
      
    },
    //使用点评模板
    async useMark() {
      let { data } = await this.$post("api/comment/getAllTemplate", {});
      this.markList = data.data.list;
      this.isFlot = !this.isFlot;
    },
    //保存点评模板
    saveMarkModel() {
      this.$post("api/comment/addTemplate", {
        title: this.modelTitle,
        comment: this.modelMsg,
      });
    },
    //修改模板
    markChange(val) {
      this.modelTitle = val.title;
      this.modelMsg = val.comment;
    },
    //修改还是新增
    modelTypeChange() {
      this.modelTitle = "";
      this.modelMsg = "";
    },
    //发布点评
    handComment() {
      this.$post("api/test/setPubWhoCheck", {
        publishId: this.info.publishId,
        comment: this.mark,
        isView: this.showResult ? 1 : 2,
      });
      this.isInfo = false;
      this.getResult()
    },
    //全选
    handAll(val) {
      this.checkLists = val ? [...this.resultList] : [];
    },
    handChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.resultList.length;
    },
    clickRow (itemObj) {
      this.nowClickRow = itemObj
      // let fIndex = this.checkLists.indexOf(itemObj)
      // if (fIndex > -1) {
      //   this.checkLists.splice(fIndex, 1)
      // } else {
      //   this.checkLists.push(itemObj)
      // }
    },
    //分页
    changePage(page) {
      this.queryObj.page = page;
      this.getResult();
    },
    //日期格式转换
    formatDate(time) {
      return formatDate1(time);
    },
    //选择日期
    clickDay(val) {
      if (this.markDate.length < 2) {
        this.markDate.push(val);
      } else {
        if (new Date(val) > new Date(this.markDate[1])) {
          this.$set(this.markDate, 1, val);
        } else if (new Date(val) < new Date(this.markDate[0])) {
          this.$set(this.markDate, 0, val);
        } else {
          this.$set(this.markDate, 0, val);
          this.$set(this.markDate, 1, val);
        }
      }
      this.startDate = this.markDate[0];
      this.endDate = this.markDate[1];
    },
    changeDate(val) {
      console.log(val);
    },


    


    //============================
    // 数据批量操作

    batchingStart () {
      this.batchingObj.isOn = true
      this.batchingObj.loading = true
      this.getResult()
    },

    batchingEnd () {
      this.batchingObj.isOn = false
      this.batchingObj.loading = false
      this.getResult({page: 1})
    },


    batchingDelete () {
      let itemList = [],
          itemTypeName = ''
      if (this.checkLists.length > 0) {
        itemList = this.checkLists
        itemTypeName = '勾选'
      } else {
        this.$myMessage("请勾选需要操作的数据");
        return;
      }
      
      let foo = ()=>{
        let ids = itemList.map((item) => {
          return item.publishId;
        });
        
        const loading = this.$loading({
          lock: true,
          text: '处理中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$post("api/test/tableResultOperate", {
          testType: 3,
          type: 4,
          id: ids.toString(),
          publishId: ids.toString(),
        }).then(()=>{
          this.isInfo = false;
          this.getResult();
          loading.close();
        }).catch((err) => {
          loading.close();
        });
      }

      this.$popup({
        title: '提示',
        content: '是否要删除' + itemTypeName + '的记录？',
        saveFoo: () => {
          foo()
        },
      })
  
    },

    batchingGetTableData (qObj) {
      this.nowClickRow = null
      this.checkAll = false;
      this.checkLists = [];

      this.queryObj.total = 0
      this.batchingObj.dataNum = 0
      this.batchingObj.loading = true
      this.batchingObj.loadingText = '获取数据中'

      let nowList = [],
          nowPage = 1,
          pageSize = 200

      let getData = (page = 1) => {

        nowPage = page

        this.$post("api/test/getTableResultList", {
          curPage: page,
          pageSize: pageSize,
          testType: 3,
          name: this.search,
          starttime: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
          endtime: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
          sex: qObj.sex,
          catId: qObj.cid,
          title_desc: qObj.sort,
          time_desc: qObj.time,
          isView: qObj.status,
        }).then(({ data }) => {
          if (!this.batchingObj.isOn) {
            // 只有在批量处理开启时，才继续执行
            return
          }

          let dataList = data.data.list || []
          nowList.push(...dataList)

          this.total = data.data.total
          this.queryObj.total = data.data.total
          this.batchingObj.dataNum += dataList.length
          this.batchingObj.loadingText = `获取数据中(${ this.batchingObj.dataNum }/${ this.total })`
          
          if (dataList.length <= 0) {
            console.log('结束')
            this.batchingObj.loading = false

            this.resultList = nowList.map((item, index)=>{
              return  {
                ...item,
                index,
              }
            })

          } else {
            console.log('完成：' + page)
            getData(page + 1)
          }
        }).catch((err) => {
          
          this.batchingObj.isOn = false
          this.batchingObj.loading = false
        });
      }

      getData(1)

    },
    

  },
  mounted() {
    this.getResult({});
    //this.handEcharts();
  },
  components: {
    "l-button": lButton,
    "l-dialog": lDialog,
    userResult,
    Calendar,
  },
};
</script>

<style lang='less' scoped>
.viewContent {
  //弹出框
  /deep/.markDialog {
    z-index: 102;
    .dialog {
      height: 460px;
      width: 750px;
      .content {
        padding: 41px 0 0 58px;
        .ipt {
          display: flex;
          align-items: flex-start;
          font-size: 14px;
          .el-radio-group {
            margin-top: 2px;
          }
          .el-input__inner,
          .el-textarea__inner {
            border: 0;
            background: #f0f0f0;
          }
        }
      }
    }
  }
  //详情
  /deep/.msgDialog .dialog {
    width: 1000px;
    height: 750px;
    .content {
      display: flex;
    }
    .oneLeft {
      width: 719px;
      overflow-y: auto;
      border-right: 1px solid #f0f0f0;
      padding-left: 30px;
      box-sizing: border-box;
      h1 {
        padding-top: 27px;
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        color: #333333;
      }
      .tag {
        font-size: 14px;
        text-align: center;
        color: #777;
        margin: 10px 0 26px 0;
      }
      .tab {
        max-height: 295px;
        overflow-y: auto;
      }
      table {
        font-size: 14px;
        border-collapse: collapse;
        text-align: center;
        th {
          background: #f7f7f7;
          height: 40px;
          color: #777777;
          font-weight: 400;
        }
        tr {
          position: relative;
        }
        td {
          position: relative;
          height: 50px;
          color: #333333;
          border-bottom: 1px solid #f0f0f0;
          button {
            height: 32px;
            width: 60px;
          }
        }
        .bad {
          background: red;
          height: 10px;
          width: 10px;
          border-radius: 50%;
          position: absolute;
          top: 6px;
          right: 16px;
        }
      }
      .markTitle {
        text-align: center;
        color: #333333;
        margin: 28px 0 20px 0;
      }
      .eval {
        height: 200px;
        width: 640px;
        overflow: hidden;
        border: 1px solid #f0f0f0;
        border-radius: 10px;
        .el-textarea__inner {
          height: 160px;
          border: 0;
          background: #f0f0f0;
        }
        .el-checkbox__label {
          display: inline-block;
          color: #333;
        }
        .foot {
          color: #333;
          height: 39px;
          display: flex;
          align-items: center;
          padding-left: 20px;
        }
        .mark {
          position: relative;
          display: flex;
          margin-left: 250px;
          img {
            width: 16px;
          }
          .flot {
            position: absolute;
            top: -160px;
            left: -10px;
            width: 120px;
            height: 150px;
            overflow: auto;
            background: #ffffff;
            border-radius: 6px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
            li {
              height: 50px;
              line-height: 50px;
              text-align: center;
              border-bottom: 1px solid #f0f0f0;
              box-sizing: border-box;
              &:hover {
                background: #f0f0f0;
              }
            }
          }
        }
      }
    }
    .left {
      width: 719px;
      overflow-y: auto;
      border-right: 1px solid #f0f0f0;
      padding-left: 59px;
      box-sizing: border-box;
      .tit {
        color: #404040;
        padding-top: 39px;
      }
      .tag {
        color: #404040;
        margin-bottom: 15px;
      }
      .tag:nth-child(1) {
        text-indent: -8px;
      }
      // .tag+.tag {
      //   text-indent: 26px;
      // }
      .msg {
        font-size: 14px;
        color: #555555;
        line-height: 30px;
        // text-indent: 2em;
        word-break: break-all;
        text-align: justify;
        margin-bottom: 20px;
      }
    }
    .right {
      font-size: 14px;
      width: 280px;
      box-sizing: border-box;
      .tit {
        margin: 39px 0 29px 0;
        text-align: center;
        color: #5f5f5f;
      }
      p {
        margin-left: 30px;
        margin-bottom: 25px;
      }
      span {
        color: #555;
      }
      .btn {
        position: absolute;
        height: 40px;
        width: 240px;
        text-align: center;
        line-height: 40px;
        bottom: 50px;
        right: 20px;
        button {
          width: 70px;
          margin: 0 5px;
        }
      }
      .btn2 {
        position: absolute;
        height: 40px;
        width: 240px;
        text-align: center;
        line-height: 40px;
        bottom: 50px;
        right: 20px;
        button {
          width: 80px;
          margin: 0 5px;
        }
      }
    }
  }
  /deep/.delLog {
    width: 350px;
    height: 240px;
    p {
      padding: 49px 0 24px 0;
      color: #333333;
      text-align: center;
    }
  }
  .search {
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 60px;
    .el-input {
      width: 320px;
      border-radius: 20px;
      overflow: hidden;
    }
    /deep/.el-input__inner {
      background-color: rgba(49, 112, 255, 0.5);
      border-color: rgba(49, 112, 255, 0.5);
      font-size: 18px;
      color: #fff;
    }
    /deep/.el-input__icon {
      font-size: 22px;
      color: #fff;
    }
    /deep/.el-input-group__append {
      background-color: #3170ff;
      color: #fff;
      border-radius: 20px;
      border-color: #3170ff;
      left: -20px;
    }
  }
  .table {
    margin-top: 20px;
    height: 770px;
    width: 1430px;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    .type {
      height: 60px;
      line-height: 60px;
      color: #222222;
      background: #f0f0f0;
      text-align: center;
    }
    .grid {
      display: flex;
      .right {
        width: 175px;
        height: 570px;
        box-sizing: border-box;
        border-left: 1px solid #f0f0f0;
        padding-left: 28px;
        button {
          height: 40px;
          line-height: 40px;
          width: 110px;
          font-size: 14px;
          border-radius: 6px;
          margin-top: 16px;
        }
      }
    }
    table {
      font-size: 14px;
      tr {
        height: 55px;
        text-align: center;
      }
      th {
        color: #555;
        font-weight: 400;
        position: relative;
        .el-checkbox {
          margin-right: 5px;
        }
      }
      td {
        height: 55px;
        .el-checkbox {
          margin: 0 20px 0 5px;
        }
      }
      .td1 {
        display: flex;
        align-items: center;
        position: relative;
        .bad {
          position: absolute;
          left: 72px;
          top: 0px;
          height: 10px;
          width: 10px;
          background-color: red;
          border-radius: 50%;
        }
        img {
          height: 36px;
          width: 36px;
          margin-right: 18px;
          border-radius: 50%;
          border: 2px solid #3170ff;
        }
      }
      .td4 {
        display: flex;
        align-items: center;
        height: 55px;
        box-sizing: border-box;
        img {
          margin: 0 20px 0 30px;
          width: 40px;
          height: 20px;
        }
      }
      
      th,
      td {
        border-bottom: 1px solid #f0f0f0;
      }
      button {
        height: 40px;
        width: 80px;
        border-radius: 6px;
        border: 0;
        font-size: 14px;
      }
      .edit {
        margin-right: 15px;
        background: #3170ff;
        color: #fff;
      }
      .del {
        background: #f0f0f0;
        color: #333333;
      }
    }
  }
  .el-pagination {
    bottom: 65px;
  }

  .exportingAllBox {
    width: 640px;
    .box-main {
      max-height: 570px;
      padding: 22px 0 24px 40px;
      overflow: auto;
      .label-box_row {
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #333;
        line-height: 50px;
      }
      .value-box_row {
        display: flex;
        font-size: 14px;
        color: #333333;
        /deep/.scale-input {
          width: 410px;
          height: 40px;
          .el-input__inner {
            background: #eaf0ff;
            border-color: #3170ff;
            border-radius: 4px;
            font-size: 14px;
            color: #555;
          }
        }
        .input {
          width: 400px;
        }
        /deep/.el-input .el-input__inner {
          background-color: #f0f0f0;
        }
        .button {
          width: 80px;
          height: 40px;
          margin-left: 10px;
          line-height: 40px;
          font-size: 14px;
          color: #fff;
        }
        /deep/.el-checkbox-group {
          display: flex;
          flex-wrap: wrap;
          >div {
            width: 175px;
            height: 34px;
            line-height: 34px;
            margin-right: 16px;
          }
          &.checkbox-col >div {
            width: 84px;
            height: 40px;
            line-height: 40px;
            margin-right: 16px;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #3170ff;
          }
          .el-checkbox__label {
            display: inline-block;
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #333333;
          }
        }
        .box-label {
          margin-right: 15px;
          >span {
            display: inline-block;
            min-width: 85px;
            line-height: 40px;
            white-space: nowrap;
          }
        }
      }
      .value-box_sex {
        margin-top: 10px;
        /deep/.el-checkbox-group {
          >div {
            width: auto;
            height: 40px;
            line-height: 40px;
            margin-right: 60px;
          }
        }
      }
      .value-box_date {
        margin-top: 10px;
        align-items: center;
        >span {
          margin: 0 15px;
        }
        .el-date-editor {
          width: 180px;
        }
      }

      .label-total {
        width: 510px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 14px;
        color: #333;
        >span {
          position: relative;
          display: inline-block;
          &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: -60px;
            display: block;
            width: 50px;
            height: 1px;
            background: #dddddd;
          }
          &::after {
            content: "";
            position: absolute;
            top: 50%;
            right: -60px;
            display: block;
            width: 50px;
            height: 1px;
            background: #dddddd;
          }
        }
      }
    }
    .btn-box_bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 60px;
      border-top: 1px solid #dddddd;
      .button+.button {
        margin-left: 20px;
      }
    }
  }
  /deep/.scaleBox {
    .el-checkbox {
      margin-right: 14px;
    }
    .th {
      font-size: 14px;
      color: #555;
      display: flex;
      height: 50px;
      align-items: center;
    }
    .tb {
      background: #f6f6f6;
      height: 580px;
      display: flex;
      font-size: 14px;
      .tbl {
        width: 160px;
        height: 100%;
        border-right: 1px solid #e5e5e5;
        color: #333;
        overflow: auto;
        li {
          height: 60px;
          line-height: 60px;
          padding-left: 15px;
          border-bottom: 1px solid #e5e5e5;
          box-sizing: border-box;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .active {
          background: rgba(49, 112, 255, 0.1);
        }
      }
      .autoTbr {
        overflow: auto;
      }
      .tbr {
        // display: flex;
        // flex-wrap: wrap;
        // align-content: flex-start;
        width: 290px;
        .el-checkbox__label {
          display: inline-block !important;
          color: #555;
        }
        li {
          // width: 334px;
          height: 46px;
          line-height: 46px;
          padding-left: 10px;
          box-sizing: border-box;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .exportingBox {
    width: 600px;
    padding: 20px 0 30px 40px;
    .value-box_row {
      display: flex;
      font-size: 14px;
      color: #333333;
      .input {
        width: 400px;
      }
      /deep/.el-input .el-input__inner {
        background-color: #f0f0f0;
      }
      .box-label {
        margin-right: 15px;
        >span {
          display: inline-block;
          min-width: 85px;
          line-height: 40px;
          white-space: nowrap;
        }
      }
    }

    .label-total {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      color: #333;
    }
  }
  .data-table {
    width: 1395px;
    max-height: 620px;
    .grid {
      width: 100%;
      >div {
        width: 100%;
      }
    }
    // table tr {
    //   position: relative;
    //   height: 57px !important;
    //   border-bottom: none !important;
    //   &::after{		
    //     content:"";
    //     position: absolute;
    //     display: block;
    //     background: #F0F0F0 !important;
    //     width: 100%;
    //     height: 1px;
    //     left: 0;
    //     bottom: 0;
    //   }
    // }
  }
}
</style>